import { APP_CONFIG } from 'services/app-config'
import { axiosJWT } from 'modules/axios'

export function setLineReservation(number) {
  return axiosJWT({
    method: 'PATCH',
    url: `${APP_CONFIG.sales_cluster}/v1/phone-numberings/${number}`,
  }).then(resp => resp.data)
}
